import { auditReports } from '@mi-front/api-clients';
import { LinkItem } from '@mi-front/ui';
import { defineMessage } from 'react-intl';
import { useIntl } from 'react-intl';
import { useAodFactory } from '../../aod-rules-add/custom/AodFactory';
import { aodRoutes } from '../../../routing/routes';

const tabMessages = {
  info: defineMessage({
    id: 'audit.aod.rules.view.tabs.info',
    defaultMessage: 'Información',
  }),
  reportConfig: defineMessage({
    id: 'audit.aod.rules.view.tabs.reportConfig',
    defaultMessage: 'Configuración de Reporte',
  }),
  exportOptions: defineMessage({
    id: 'audit.aod.rules.view.tabs.exportOptions',
    defaultMessage: 'Export de evidencia',
  }),
  exportConditions: defineMessage({
    id: 'audit.aod.rules.view.tabs.exportConditions',
    defaultMessage: 'Condiciones de Export',
  }),
  runs: defineMessage({
    id: 'audit.aod.rules.view.tabs.runs',
    defaultMessage: 'Ejecuciones',
  }),
};

/**
 * Returns the tab items for the AOD rule view header (Info, Report config, Export options, etc.).
 * Tabs are filtered by report type (ExportOptions/ExportConditions only when provided by the factory).
 */
export function useAodRuleViewTabs(rule: auditReports.AodRule): LinkItem[] {
  const { $t } = useIntl();
  const { views } = useAodFactory(rule.reportType);
  const basePath = aodRoutes.ruleView.gen(rule.id);

  const tabs: (LinkItem | null)[] = [
    {
      exact: true,
      to: basePath,
      text: $t(tabMessages.info),
      isActive: (_match, location) => {
        const p = location.pathname;
        return p === basePath || p === basePath + '/';
      },
    },
    {
      to: aodRoutes.ruleViewTab.gen(rule.id, 'report-config'),
      text: $t(tabMessages.reportConfig),
      isActive: (_match, location) =>
        location.pathname === aodRoutes.ruleViewTab.gen(rule.id, 'report-config'),
    },
    views.ExportOptions
      ? {
          to: aodRoutes.ruleViewTab.gen(rule.id, 'export-options'),
          text: $t(tabMessages.exportOptions),
          isActive: (_match, location) =>
            location.pathname === aodRoutes.ruleViewTab.gen(rule.id, 'export-options'),
        }
      : null,
    views.ExportConditions
      ? {
          to: aodRoutes.ruleViewTab.gen(rule.id, 'export-conditions'),
          text: $t(tabMessages.exportConditions),
          isActive: (_match, location) =>
            location.pathname === aodRoutes.ruleViewTab.gen(rule.id, 'export-conditions'),
        }
      : null,
    {
      to: aodRoutes.ruleViewTab.gen(rule.id, 'runs'),
      text: $t(tabMessages.runs),
      isActive: (_match, location) =>
        location.pathname === aodRoutes.ruleViewTab.gen(rule.id, 'runs'),
    },
  ];

  return tabs.filter((v): v is LinkItem => Boolean(v));
}
